import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: "used-category",
  data: function data() {
    return {
      searchForm: {},
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据

      // 表单
      form: {
        icon: "",
        chName: "",
        enName: "",
        twName: ""
      },
      dialogVisible: false,
      // 弹窗状态

      currentRow: {},
      shareDialogVisible: false,
      shareForm: {
        title: {
          zh: "",
          tw: "",
          en: ""
        },
        img: {
          zh: "",
          tw: "",
          en: ""
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    updateSort: function updateSort(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.sortUsedCategory(row);
            case 1:
              _this2.$message.success("操作成功");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateShareDialog: function updateShareDialog(row) {
      this.currentRow = row;
      if (row.share) {
        this.shareForm = row.share;
      } else {
        this.shareForm = {
          title: {
            zh: "",
            tw: "",
            en: ""
          },
          img: {
            zh: "",
            tw: "",
            en: ""
          }
        };
      }
      this.shareDialogVisible = true;
    },
    updateCategoryCard: function updateCategoryCard() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(!_this3.shareForm.title.zh || !_this3.shareForm.title.tw || !_this3.shareForm.title.en)) {
                _context3.n = 1;
                break;
              }
              _this3.$message.error("请输入分享标题");
              return _context3.a(2);
            case 1:
              if (!(!_this3.shareForm.img.zh || !_this3.shareForm.img.tw || !_this3.shareForm.img.en)) {
                _context3.n = 2;
                break;
              }
              _this3.$message.error("请上传分享图片");
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return _this3.$api.updateCategoryCard({
                id: _this3.currentRow.id,
                share: _this3.shareForm
              });
            case 3:
              _this3.shareDialogVisible = false;
              _this3.getData();
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getData: function getData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getUsedCategoryList();
            case 1:
              res = _context4.v;
              _this4.tableData = res.data;
              _this4.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.saveUsedCategory({
                chName: _this5.form.chName,
                enName: _this5.form.enName,
                twName: _this5.form.twName,
                icon: _this5.form.icon,
                id: _this5.form.id
              });
            case 1:
              _this5.dialogVisible = false;
              _this5.form = {};
              _this5.getData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};